<template>
    <div class="pages-user">
        <content-box :title-left=true>
            <div class="whyc-breadcrumb" slot="title">当前位置：用户管理</div>
            <router-view></router-view>
        </content-box>
        
    </div>
</template>

<script>
import ContentBox from '@/components/ContentBox'

export default {
    name: 'PagesUser',
    components: {
        ContentBox
    }
}
</script>

<style scoped>
.pages-user {
    height: 100%;
    box-sizing: border-box;
	padding-top: 0.08rem;
	padding-bottom: 0.08rem;
}
</style>


